export const TIMEOUT = import.meta.env.VITE_TIMEOUT

export const AUTH_URL = import.meta.env.VITE_AUTH_URL //TODO ALTERAR PARA AZURE NO FUTURO

export const REACTCORE_URL = import.meta.env.VITE_REACTCORE_URL
export const CORE_URL = import.meta.env.VITE_CORE_URL
export const IBGE_URL = import.meta.env.VITE_IBGE_URL

export const WEBPUSH_URL = import.meta.env.VITE_WEBPUSH_URL

export const CARTEIRA_URL = import.meta.env.VITE_CARTEIRA_URL

export const CARTEIRA_URL_APP = import.meta.env.VITE_CARTEIRA_URL_APP

export const CAMPANHA_URL = import.meta.env.VITE_CAMPANHA_URL

export const COOPERCRED_URL = import.meta.env.VITE_COOPERCRED_URL

export const PANELS_URL = import.meta.env.VITE_PANELS_URL //TODO ALTERAR PARA AZURE NO FUTURO

export const CAMPANHA_OAUTH_CLIENT_ID = import.meta.env.VITE_CAMPANHA_OAUTH_CLIENT_ID
export const CAMPANHA_OAUTH_CLIENT_SECRET = import.meta.env.VITE_CAMPANHA_OAUTH_CLIENT_SECRET

export const CARTEIRA_OAUTH_CLIENT_ID = import.meta.env.VITE_CARTEIRA_OAUTH_CLIENT_ID
export const CARTEIRA_OAUTH_CLIENT_SECRET = import.meta.env.VITE_CARTEIRA_OAUTH_CLIENT_SECRET